import React from 'react';

import ComponentCounter from './ComponentCounter';

const ComponentBar = props => {
    const checkins = props.checkins;

    return (
        <div className="ComponentBar">
            {['1', '2', '3'].map(checkinKey => {
                let checkin = checkins[checkinKey];
                checkin.range = 100;

                let count = checkin.count;
                if (!Number.isInteger(count)) {
                    count = Math.ceil(count.toFixed(2));
                }

                return (
                    <div key={checkinKey} className="CheckinStatusBar">
                        <div className="Checkin">
                            <ComponentCounter target={checkin} current={checkin.count} />
                            <p>{count}</p>
                        </div>
                        <div className="Label">Check-in {checkinKey}</div>
                    </div>
                );
            })}
        </div>
    );
};

export default ComponentBar;
